export const LAYER_SPACE = "space";
export const LAYER_MINDMAP = "mindmap";
export const LAYER_VOLCANO = "volcano";
export const LAYER_CRYSTAL = "crystal";
export const LAYER_DRAWING = "drawing";
export const TRANSITION_DURATION = 550;
